import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map, shareReplay} from 'rxjs/operators';
import {EcaSetupConfigurationService} from '@drc-eca/eca-components-lib';

export interface FormSelectOptions {
  [key: string]: FormSelectOption[];
}

export interface FormSelectOption {
  value: string;
  label: string;
}

@Injectable({
  providedIn: 'root'
})
export class SetupConfigService {
  config = inject(EcaSetupConfigurationService);

  readonly CONFIG_KEY = 'localScanning';
  readonly FORM_SELECT_OPTIONS_KEY = 'formSelectOptions';

  localScanningConfig$: Observable<any>;

  constructor() {
    this.localScanningConfig$ = this.getLocalScanningConfig().pipe(
      shareReplay(1),
    );
  }

  getLocalScanningConfig(): Observable<any> {
    return this.config.getAttributesForClientByTag(
      localStorage.getItem('client'),
      this.CONFIG_KEY,
      {
        // cache can either be boolean or an object, where cache.cache becomes the boolean checked
        cache: {
          cache: true
        }
      });
  }

  // find an attribute value from the array of attributes coming back from the eca setup config service.
  // NOTE : retrieve it by key instead of assuming the order will be what is shown in the ECA Setup Config UI
  getEcaAttributeValueByKeyName(keyName: string, attributeArray: any[]) : any {
    const ecaAttributeContainer = attributeArray.find(attributeContainer => attributeContainer.attribute.key.toLowerCase() === keyName.toLowerCase());

    if (ecaAttributeContainer) {
      return ecaAttributeContainer.value;
    }

    return null;
  }

  getFormSelectOptions(): Observable<FormSelectOptions> {
    return this.getLocalScanningConfig()
      .pipe(
        map((res: any[]) => {
          return this.getEcaAttributeValueByKeyName(this.FORM_SELECT_OPTIONS_KEY, res)
        })
      );
  }
}


